import {
  call,
  put,
  takeLatest,
  cancel,
  takeEvery,
  select,
} from 'redux-saga/effects';
import * as action from 'actions';
import {
  CUSTOMERS_FEEDBACK_PAGE_REQUEST,
  CUSTOMERS_FEEDBACK_LIST_FEEDBACK_REQUEST,
  CUSTOMERS_FEEDBACK_CHANGE_DATE,
  CUSTOMERS_FEEDBACK_SUBMIT_REPLY_REQUEST,
  CUSTOMERS_FEEDBACK_MESSAGES_REQUEST,
  CUSTOMERS_FEEDBACK_RECEIPT_REQUEST,
  CUSTOMERS_FEEDBACK_ON_CLICK_ROW,
} from 'actions/customers/feedback/constants';
import { LOGOUT } from 'actions/constants';

import {
  listFeedbackRequest,
  setListFeedback,
  setFeedbackMessages,
  setReceiptFeedback,
  setCurrentPage,
  setTotalPage,
} from 'actions/customers/feedback';
import { getFilteredDate } from 'api/get-filtered-date';
import moment from 'moment';
import { getTransactionDetail } from 'api/reports';
import { reset, initialize } from 'redux-form';
import { showPageLoadingSpinner } from 'actions/loadingSpinner';
import * as actNotif from 'actions/notifications';
import {
  getFeedbackMessages,
  getCustomerServiceFeedbacks,
  getCustomerServiceFeedbackMessages,
  customerServiceReplyByBusiness,
} from 'api/customer-feedbacks';
import * as clevertapCustomersFeedback from 'clevertap/customers/feedback';

export const businessState = state => state.moka.user.business;

function* fillSearchForm(startDate, endDate) {
  yield put(initialize('search', { date: { startDate, endDate } }));
}

export function* feedbackPageRequestFlow() {
  yield put(setListFeedback([]));
  clevertapCustomersFeedback.customerFeedbackStart();
  // will be set false by feedback request saga
  try {
    yield put(action.showProgressBar());
    yield put(showPageLoadingSpinner(true));
    // call date
    const filteredDate = yield call(getFilteredDate);
    const startDate = moment(filteredDate.data.start_date, 'YYYY-MM-DD');
    const endDate = moment(filteredDate.data.end_date, 'YYYY-MM-DD');
    // set calendar state
    yield call(fillSearchForm, startDate, endDate);
    const startDateFormatted = startDate.format('D/M/YYYY');
    const endDateFormatted = endDate.format('D/M/YYYY');
    yield put(
      listFeedbackRequest({
        start: startDateFormatted,
        end: endDateFormatted,
        page: 1,
      })
    );
    $('#customer-feedback-detail').hide();
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

export function* getCustomerFeedbacksFlow(request) {
  try {
    yield put(action.showProgressBar());
    const {
      payload: { query, previousFeedback },
    } = request;
    const startDate = query.start;
    const endDate = query.end;
    const { page } = query;

    const startDateFormatted = moment(startDate, 'DD-MM-YYYY')
      .startOf('day')
      .toISOString();
    const endDateFormatted = moment(endDate, 'DD-MM-YYYY')
      .endOf('day')
      .toISOString();
    const queryParams = {
      fromDate: startDateFormatted,
      toDate: endDateFormatted,
      customer: true,
      messages: true,
      page: page - 1,
    };

    const feedbacksRes = yield call(getCustomerServiceFeedbacks, queryParams);
    let resFeedbacks = feedbacksRes.data.feedbacks;

    const business = yield select(businessState);

    const results = [];
    resFeedbacks.forEach(function(items) {
      if (
        items.feedback_details !== null &&
        items.feedback_details.length !== 0
      ) {
        const lengthDetails = items.feedback_details.length;
        const feedbackDate =
          items.feedback_details[lengthDetails - 1].created_at ||
          items.created_at;
        const result = {
          id: items.id,
          mode: items.mode,
          feedback_type: items.type,
          customer_id: items.customer.id,
          created_at: items.created_at,
          updated_at: items.updated_at,
          business_id: business.id,
          business_name: business.name || '',
          feedback_token: null,
          payment_id: items.payment_id,
          outlet_id: items.outlet_id,
          comment: items.feedback_details[lengthDetails - 1].body,
          customer_name:
            items.customer.name === '-' ? null : items.customer.name,
          customer_email: items.customer.email,
          customer_phone: items.customer.phone,
          business_logo_url: business.logo != null ? business.logo.url : '',
          feedback_from: items.feedback_details[0].from,
          feedback_date: moment(feedbackDate).format('DD-MM-YYYY'),
        };
        results.push(result);
      }
    });
    resFeedbacks = {
      results,
      total_pages: page,
      total_count: resFeedbacks.length,
    };

    if (resFeedbacks) {
      let feedbacks;
      if (previousFeedback) {
        feedbacks = previousFeedback.concat(resFeedbacks.results);
      } else {
        feedbacks = resFeedbacks.results;
      }
      yield put(setCurrentPage(page));
      yield put(setTotalPage(resFeedbacks.total_pages));
      yield put(setListFeedback(feedbacks));
    }
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(showPageLoadingSpinner(false));
    yield put(action.hideProgressBar());
  }
}

export function* changeDateFeedbackFlow(request) {
  yield put(setListFeedback([]));
  // will be set false by feedback request saga
  yield put(showPageLoadingSpinner(true));
  const { payload } = request;
  const { startDate, endDate } = payload;
  const startDateFormatted = moment(startDate).format('D/M/YYYY');
  const endDateFormatted = moment(endDate).format('D/M/YYYY');
  yield put(
    listFeedbackRequest({
      start: startDateFormatted,
      end: endDateFormatted,
      page: 1,
    })
  );
}

/**
 * TODO remove
 * @param request
 */
export function* getFeedbackMessagesFlow(request) {
  try {
    yield put(action.showProgressBar());
    yield put(showPageLoadingSpinner(true));
    const { payload } = request;
    const { id } = payload;
    let feedbackBusinessName = '';
    const feedbackMessagesRes = yield call(getFeedbackMessages, id);
    const feedbackMessages = feedbackMessagesRes.data;
    if (feedbackMessages) {
      yield put(setFeedbackMessages(feedbackMessages));
      if (feedbackMessages.business_name.length > 12) {
        feedbackBusinessName = `${feedbackMessages.business_name.slice(
          0,
          12
        )}...- `;
      } else {
        feedbackBusinessName = `${feedbackMessages.business_name.slice(
          0,
          12
        )} - `;
      }
      yield put(
        initialize('feedbackReplyForm', {
          feedbackfrom: feedbackMessages.feedback_from,
          comment:
            feedbackMessages.feedback_from === 'sms'
              ? feedbackBusinessName
              : '',
          business_name: feedbackBusinessName,
        })
      );
    }
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(showPageLoadingSpinner(false));
    yield put(action.hideProgressBar());
  }
}

/**
 * TODO remove
 * @param request
 */
export function* getFeedbackReceiptFlow(request) {
  try {
    yield put(action.showProgressBar());
    yield put(showPageLoadingSpinner(true));
    const { payload } = request;
    const { id } = payload;
    const transactionDetail = yield call(getTransactionDetail, id);
    if (transactionDetail.data) {
      yield put(setReceiptFeedback(transactionDetail.data));
    }
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(showPageLoadingSpinner(false));
    yield put(action.hideProgressBar());
  }
}

export function* submitReplyRequestFlow(request) {
  const { data } = request.payload;
  clevertapCustomersFeedback.customerFeedbackReply({ feedback: data });
  try {
    yield put(action.showProgressBar());

    yield call(customerServiceReplyByBusiness, data.feedback_id, data);

    const business = yield select(businessState);
    const queryParams = {
      customer: true,
      messages: true,
    };
    const feedbackMessagesRes = yield call(
      getCustomerServiceFeedbackMessages,
      data.feedback_id,
      queryParams
    );
    const { feedback } = feedbackMessagesRes.data;

    const messages = [];
    feedback.feedback_details.forEach(function(item) {
      const message = {
        name: feedback.customer.name === '-' ? null : feedback.customer.name,
        email: feedback.customer.email,
        is_customer: item.type === 'Customer',
        profile_pict_url: null,
        feedback_type: feedback.type,
        mode: feedback.mode,
        comment: item.body,
        feedback_from: item.from,
        created_at: item.created_at,
      };
      messages.push(message);
    });

    const feedbackMessages = {
      business_name: business.name || '',
      customer_name: feedback.customer.name,
      customer_email: feedback.customer.email,
      customer_phone: feedback.phone,
      business_logo_url: business.logo ? business.logo.url : '',
      feedback_from: feedback.feedback_details[0].from,
      can_reply: data.can_reply,
      messages,
    };

    yield put(setFeedbackMessages(feedbackMessages));

    yield put(reset('feedbackReplyForm'));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

export function* onClickRowFlow(request) {
  const {
    payload: { feedback },
  } = request;
  try {
    yield put(action.showProgressBar());
    yield put(showPageLoadingSpinner(true));
    const transactionDetail = yield call(
      getTransactionDetail,
      feedback.payment_id
    );
    if (transactionDetail.data) {
      yield put(setReceiptFeedback(transactionDetail.data));
    }

    const queryParams = {
      customer: true,
      messages: true,
    };
    const feedbackMessagesRes = yield call(
      getCustomerServiceFeedbackMessages,
      feedback.id,
      queryParams
    );
    let feedbackMessages = feedbackMessagesRes.data.feedback;

    const messages = [];
    feedbackMessages.feedback_details.forEach(function(item) {
      const message = {
        name:
          feedbackMessages.customer.name === '-'
            ? null
            : feedbackMessages.customer.name,
        email: feedbackMessages.customer.email,
        is_customer: item.type === 'Customer',
        profile_pict_url: null,
        feedback_type: feedbackMessages.type,
        mode: feedbackMessages.mode,
        comment: item.body,
        feedback_from: item.from,
        created_at: item.created_at,
      };
      messages.push(message);
    });

    feedbackMessages = {
      customer_name: feedbackMessages.customer.name,
      customer_email: feedbackMessages.customer.email,
      customer_phone: feedbackMessages.phone,
      business_logo_url: feedback.business_logo_url,
      business_name: feedback.business_name,
      feedback_from: feedbackMessages.feedback_details[0].from,
      messages,
      can_reply: feedbackMessagesRes.data.can_reply,
    };

    if (feedbackMessages) {
      let feedbackBusinessName = '';

      yield put(setFeedbackMessages(feedbackMessages));
      if (feedbackMessages.business_name.length > 12) {
        feedbackBusinessName = `${feedbackMessages.business_name.slice(
          0,
          12
        )}...- `;
      } else {
        feedbackBusinessName = `${feedbackMessages.business_name.slice(
          0,
          12
        )} - `;
      }
      yield put(
        initialize('feedbackReplyForm', {
          feedbackfrom: feedbackMessages.feedback_from,
          comment:
            feedbackMessages.feedback_from === 'sms'
              ? feedbackBusinessName
              : '',
          business_name: feedbackBusinessName,
          canReply: feedbackMessages.can_reply,
        })
      );
    }
    clevertapCustomersFeedback.customerFeedbackSelect({
      feedback,
      transaction: transactionDetail.data,
      feedbackMessages,
    });
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(showPageLoadingSpinner(false));
    yield put(action.hideProgressBar());
  }
}

export function* cancelAction(cancelledTasks) {
  yield cancel(...cancelledTasks);
}

export default function* customersFeedbackSaga() {
  const feedbackPage = yield takeLatest(
    CUSTOMERS_FEEDBACK_PAGE_REQUEST,
    feedbackPageRequestFlow
  );
  const feedbackList = yield takeLatest(
    CUSTOMERS_FEEDBACK_LIST_FEEDBACK_REQUEST,
    getCustomerFeedbacksFlow
  );
  const changeDate = yield takeLatest(
    CUSTOMERS_FEEDBACK_CHANGE_DATE,
    changeDateFeedbackFlow
  );
  const feedbackMessages = yield takeLatest(
    CUSTOMERS_FEEDBACK_MESSAGES_REQUEST,
    getFeedbackMessagesFlow
  );
  const feedbackReceipt = yield takeLatest(
    CUSTOMERS_FEEDBACK_RECEIPT_REQUEST,
    getFeedbackReceiptFlow
  );
  yield takeEvery(
    CUSTOMERS_FEEDBACK_SUBMIT_REPLY_REQUEST,
    submitReplyRequestFlow
  );
  yield takeLatest(CUSTOMERS_FEEDBACK_ON_CLICK_ROW, onClickRowFlow);

  // don't cancel submit reply to prevent unsent data
  yield takeEvery(LOGOUT, cancelAction, [
    feedbackPage,
    feedbackList,
    changeDate,
    feedbackMessages,
    feedbackReceipt,
  ]);
}
